// extracted by mini-css-extract-plugin
export var card = "SubscribeFormInfoCard-module--card--bb571";
export var image = "SubscribeFormInfoCard-module--image--1fe7f";
export var isBrochure = "SubscribeFormInfoCard-module--is-brochure--6e240";
export var title = "SubscribeFormInfoCard-module--title--90bf3";